import ApiWithLogging from '../utils/apiWithLogging';

/**
 * "สัญญาเช่าที่ของชิ้นนี้เคยอยู่ / อยู่ตอนนี้" — GET /devices/{id}/rental-history · GET /sims/{id}/rental-history
 * (หน้ารายละเอียดอุปกรณ์/ซิม · 28 ต.ค. 2026 · backend services/item_rental_history.py)
 *
 * ต้องมีทั้ง devices.view|sims.view และ rentals.view (backend บังคับทั้งคู่) — การ์ด gate rentals.view
 * `is_current` = สัญญาที่ถือของอยู่ตามด่าน find_rental_holder(include_draft) — ไม่ใช่จาก status ของเครื่อง/ซิม
 */
export interface ItemRentalHistoryRow {
  rental_item_id: number;
  rental_id: number;
  rental_number: string | null;
  status: string;
  company_id: number | null;
  company_name: string | null;
  site_id: number | null;
  site_name: string | null;
  rental_date: string | null;
  end_date: string | null;
  delivery_date: string | null;
  billing_start_date: string | null;
  billing_end_date: string | null;
  /** จำนวนในรายการเช่า (ของนับจำนวนอยู่หลายสัญญาพร้อมกันได้) */
  quantity: number | null;
  /** สัญญานี้ถือ/ผูกของชิ้นนี้อยู่ตอนนี้ (รวมสัญญาร่าง) · ของนับจำนวน = ทุกสัญญาที่ยังไม่จบ */
  is_current: boolean;
  /** สัญญาสถานะที่ของออกจากคลังจริง (ACTIVE / PENDING_CANCELLATION) */
  holds_inventory: boolean;
}

export interface ItemRentalHistory {
  items: ItemRentalHistoryRow[];
  total: number;
  current_rental_id: number | null;
  current_rental_item_id: number | null;
  /** อุปกรณ์แบบนับจำนวน — ไม่มี "ผู้ถือคนเดียว" (current_* = null) */
  counted?: boolean;
}

/** queryKey เดียวกันทั้งการ์ดประวัติและส่วน "การถือครองตอนนี้" — react-query ยิงครั้งเดียว */
export const itemRentalHistoryKey = (kind: 'device' | 'sim', id: number) => ['item-related', kind, id, 'rental-history'] as const;
export const ITEM_RENTAL_HISTORY_LIMIT = 10;

const itemRentalHistoryService = {
  getDeviceRentalHistory(deviceId: number, limit = 10): Promise<ItemRentalHistory> {
    return ApiWithLogging.get<ItemRentalHistory>(`/devices/${deviceId}/rental-history`, { params: { limit } }, {
      service: 'itemRentalHistoryService', action: 'view_device_rental_history', entityType: 'device', entityId: deviceId,
    });
  },
  getSimRentalHistory(simId: number, limit = 10): Promise<ItemRentalHistory> {
    return ApiWithLogging.get<ItemRentalHistory>(`/sims/${simId}/rental-history`, { params: { limit } }, {
      service: 'itemRentalHistoryService', action: 'view_sim_rental_history', entityType: 'sim', entityId: simId,
    });
  },
};

export default itemRentalHistoryService;
